function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Swiper, defaultSwiperSettings } from '../../../src/js/swiper-utils';
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll('.awards-block-block')) {
    var sliders = document.querySelectorAll('.awards-block-block');
    sliders.forEach(function (slider) {
      var developmentsSlider = new Swiper(slider.querySelector('.swiper'), _objectSpread(_objectSpread({}, defaultSwiperSettings('auto', 330, false, false)), {}, {
        centeredSlides: false,
        spaceBetween: 5,
        loop: true,
        slidesPerView: "auto",
        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
          freeMode: true,
          renderBullet: function renderBullet(index, className) {
            return '<button aria-label="Go to slide ' + (index + 1) + '" class="' + className + '">' + "</button>";
          }
        },
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev')
        },
        breakpoints: {
          300: {
            slidesPerView: 1
          },
          365: {
            slidesPerView: 2
          },
          640: {
            slidesPerView: 3
          },
          767: {
            slidesPerView: 4,
            freeMode: false
          },
          1024: {
            slidesPerView: 5,
            freeMode: false
          },
          1536: {
            slidesPerView: 7,
            freeMode: false
          }
        }
      }));
    });
  }

  var grids = document.querySelectorAll('.awards-logo-grid');
  if (!grids.length) return;
  grids.forEach(function (grid) {
    function addStars() {
      var existingStars = grid.querySelectorAll('.award-star');
      existingStars.forEach(function (star) {
        return star.remove();
      });
      var items = grid.querySelectorAll('.logo-item');
      if (items.length === 0) return;
      var gridStyle = window.getComputedStyle(grid);
      var columns = gridStyle.gridTemplateColumns.split(' ').length;
      var rows = Math.ceil(items.length / columns); // Get actual dimensions

      var firstItem = items[0];
      var itemRect = firstItem.getBoundingClientRect();
      var itemWidth = itemRect.width;
      var itemHeight = itemRect.height; // Add stars at internal intersections

      for (var row = 1; row < rows; row++) {
        for (var col = 1; col < columns; col++) {
          var star = document.createElement('div');
          star.className = 'award-star';
          var x = col * itemWidth;
          var y = row * itemHeight;
          star.style.left = "".concat(x - 12.5, "px");
          star.style.top = "".concat(y - 12.5, "px");
          grid.appendChild(star);
        }
      }
    }

    setTimeout(function () {
      addStars();
    }, 1000); // Safari fix: Wait for all images in the grid to load before positioning stars

    var images = grid.querySelectorAll('img');
    var imagePromises = Array.from(images).map(function (img) {
      if (img.complete) {
        return Promise.resolve();
      }

      return new Promise(function (resolve) {
        img.addEventListener('load', resolve);
        img.addEventListener('error', resolve);
      });
    });
    Promise.all(imagePromises).then(function () {
      addStars();
    }); // Re-render borders and stars on window resize

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        addStars();
      }, 25);
    });
  });
});